import { ApiServiceBase } from './ApiServiceBase'

export default class extends ApiServiceBase {
  async update(data: any): Promise<any> {
    return await this.call('/spa/user', {
      method: 'put',
      body: data,
    })
  }

  async updatePicture(file: Blob): Promise<any> {
    const formData: FormData = new FormData()
    formData.append('profile_picture', file)

    return await this.call('/spa/user/profile-picture', {
      method: 'put',
      body: formData,
    })
  }

  async updatePreferredLocale(locale: string): Promise<any> {
    return await this.call('/spa/user/locale', {
      method: 'put',
      body: { locale },
    })
  }

  async storeFirebaseToken(token: string, origin: string): Promise<any> {
    return await this.call('/spa/devices', {
      method: 'post',
      body: {
        firebase_token: token,
        origin,
      },
    })
  }

  async updateNotificationSettings(type: string, is_enabled: boolean): Promise<any> {
    return await this.call('/spa/user/notification-settings', {
      method: 'put',
      body: { type, is_enabled },
    })
  }

  async enableTwoFactorAuthentication(): Promise<any> {
    return await this.call('/spa/user/two-factor-authentication', {
      method: 'post',
    })
  }

  async showQrCode(): Promise<any> {
    return await this.call('/spa/user/two-factor-qr-code', {
      method: 'get',
    })
  }

  async showSetupKey(): Promise<any> {
    return await this.call('/spa/user/two-factor-secret-key', {
      method: 'get',
    })
  }

  async showRecoveryCodes(): Promise<any> {
    return await this.call('/spa/user/two-factor-recovery-codes', {
      method: 'get',
    })
  }

  async regenerateRecoveryCodes(): Promise<any> {
    return await this.call('/spa/user/two-factor-recovery-codes', {
      method: 'post',
    })
  }

  async confirmTwoFactorAuthentication(code: string): Promise<any> {
    return await this.call('/spa/user/two-factor-authentication-confirmed', {
      method: 'post',
      body: {
        code,
      },
    })
  }

  async disableTwoFactorAuthentication(): Promise<any> {
    return await this.call('/spa/user/two-factor-authentication', {
      method: 'delete',
    })
  }
}
